// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import constants from "@store/constants";
import { GetBlogCategoryArticlesApiParameter } from "@store/Framework/Services/BlogService";
import { useBlogCategoryArticlesDataView } from "@store/Framework/Store/Data/BlogCategory/BlogCategoryHooks";
import loadBlogCategoryArticles from "@store/Framework/Store/Starter/Data/Blog/Handlers/LoadBlogCategoryArticles";
import { useBlogCategoryArticlesParameter } from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategoryHooks";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/BlogCategory/Handlers/UpdateSearchFields";
import useIsFirstRender from "@toolkit/Framework/Common/Hooks/useIsFirstRender";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import qs from "qs";
import * as React from "react";
import { FC, useEffect, useState } from "react";

const BlogCategoryPage: FC<PageProps> = ({ id }) => {
    const [cacheInvalidationId] = useState(`cacheId-${uniqueId()}`);
    const { isInShell } = useShellContext();
    const isFirstRender = useIsFirstRender();
    const dispatch = useAppDispatch();
    const currentPage = useCurrentPage();
    const location = useLocation();
    const history = useHistory();
    const blogCategoryArticlesParameter = useBlogCategoryArticlesParameter();
    const blogArticlesDataView = useBlogCategoryArticlesDataView(isInShell);
    const { isLoading, value } = blogArticlesDataView;

    useEffect(() => {
        let parsedblogCategoryArticlesParameter: GetBlogCategoryArticlesApiParameter = { nodeId: "" };

        if (location.search) {
            parsedblogCategoryArticlesParameter = parseQueryString<GetBlogCategoryArticlesApiParameter>(
                location.search,
            );
        }

        dispatch(
            updateSearchFields({
                ...blogCategoryArticlesParameter,
                ...parsedblogCategoryArticlesParameter,
                nodeId: currentPage.nodeId,
                cacheInvalidationId: isInShell ? cacheInvalidationId : undefined,
                type: "Replace",
            }),
        );
    }, []);

    useEffect(() => {
        if (!isFirstRender) {
            const { nodeId, cacheInvalidationId, ...parameter } = blogCategoryArticlesParameter;
            const queryString = qs.stringify(parameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [blogCategoryArticlesParameter]);

    useEffect(() => {
        if (!isFirstRender && !value && !isLoading) {
            dispatch(
                loadBlogCategoryArticles({
                    ...blogCategoryArticlesParameter,
                    cacheInvalidationId: isInShell ? blogCategoryArticlesParameter.cacheInvalidationId : undefined,
                    nodeId: currentPage.nodeId,
                }),
            );
        }
    });

    return (
        <MobiusPage>
            <Zone contentId={id} zoneName="Content" />
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: BlogCategoryPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedParents: [constants.pageType.blogHomePage],
        allowedChildren: [constants.pageType.blogArticlePage],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
